import Vue from 'vue';
import Api from '../../api/api'

export default {
  namespaced: true,
  state: {
    likes: {},
  },
  getters: {
    getLikeForTrack: (state) =>
      (selector_code) => {
        return state.likes[selector_code]
      }
  },
  actions: {
    async fetch({ commit }) {
      const response = await Api.get('/2.0/members/me/ratings', {tokenAuth: true})
      commit('LIKES_FETCHED', response.data.ratings)
    },
    clear({ commit }) {
      commit('LIKES_CLEAR')
    },
    toggleForTrack({ dispatch, getters }, selector_code) {
      if (getters.getLikeForTrack(selector_code)) {
        dispatch('unlike', selector_code)
      } else {
        dispatch('like', selector_code)
      }
    },
    like({ commit }, selector_code) {
      commit('LIKE', selector_code);
      Api.post(`/2.0/tracks/${selector_code}/ratings`, {rating: 1}, {tokenAuth: true});
    },
    unlike({ commit }, selector_code) {
      commit('UNLIKE', selector_code);
      Api.delete(`/2.0/tracks/${selector_code}/ratings`, {tokenAuth: true});
    },
  },
  mutations: {
    LIKES_FETCHED(state, likes) {
      const likeObj = {}
      likes.forEach((like) => {
        likeObj[like.selector_code] = like.rating;
      })
      state.likes = likeObj;
    },
    LIKES_CLEAR(state) {
      state.likes = {};
    },
    LIKE(state, selector_code) {
      Vue.set(state.likes, selector_code, 1);
    },
    UNLIKE(state, selector_code) {
      Vue.delete(state.likes, selector_code);
    }
  }
}
